import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, IonFooter, useIonViewWillEnter } from '@ionic/react'
import { UseHeader, MktButton, UploadInput, ResultAlert } from '@cps'
import { virtualOrderMobx, memberMobx } from '@mobxStore'
import { useHistoryNew, toast, modalLayer } from '@utils'
import mktController from 'controllers/mktController'
import OrderProduct from '../components/OrderProduct'
import i18n from 'i18next'
import { cloneDeep, each } from '@dt/fe-utils/dist/lodash'
import MemberApi from '@api/member.api'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const GiftCard: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { orderNo } = match.params as any
  const [orderInfo, setOrderInfo] = useState<any>({})
  const [score, setScore] = useState<number>(5)
  const [message, setMessage] = useState<string>('')
  const [tag, setTag] = useState<any[]>([])
  const [medias, setMedias] = useState<any[]>([])

  const goBack = () => {
    mktController.goBack(history)
  }

  const changeTag = (key: string) => {
    const resTag = [...tag]
    const index: number = resTag.indexOf(key)
    if (index === -1) {
      resTag.push(key)
    } else {
      resTag.splice(index, 1)
    }
    setTag(resTag)
  }

  const submitComm = () => {
    MemberApi.submitComment({
      brandId: orderInfo.brandId,
      storeId: orderInfo.storeId,
      outNo: orderInfo.ordersId,
      outType: 'orders',
      message: message,
      medias: medias,
      at: tag,
      score: score,
      ext: {
        paidFee: orderInfo.paidFee,
        mobile: memberMobx.memberInfo.mobile,
        email: memberMobx.memberInfo.email
      }
    }).then((res: any) => {
      if (!res.error) {
        toast({ message: i18n.t('mkt.comment.evalSucc') })
        goBack()
      }
    }).catch((err: any) => {
      let text: string = i18n.t('mkt.comment.evalFail')
      if (err.code === 4005) {
        text = i18n.t('mkt.comment.evalFail1')
      }
      toast({ message: text })
    })
  }

  const onSubmit = () => {
    if (score === 1 && message === '') {
      toast({ message: i18n.t('mkt.comment.provideBadReviewDes') })
      return
    }
    if (score === 1) {
      modalLayer(ResultAlert, {
        children: i18n.t('mkt.comment.sureSubmitComment')
      }).then(() => {
        submitComm()
      })
    } else {
      submitComm()
    }
  }

  useIonViewWillEnter(() => {
    mktController.checkLogin(history, true, false).then(() => {
      virtualOrderMobx.getOrderDetail(orderNo).then((res: any) => {
        setOrderInfo(res)
      })
    })
  })
  return (
    <IonPage className='eval-page'>
      <UseHeader title={i18n.t('pageName.evaluate')} onBack={goBack}></UseHeader>
      <IonContent className='page-content'>
        <div className='page-body'>
          <OrderProduct orderInfo={orderInfo}></OrderProduct>
          <div className='eval-con'>
            <div className='top-area'>
              <div className='left'>
                <div className='title'>{i18n.t('mkt.comment.mealEval')}</div>
                <div className='des'>{score === 5 ? i18n.t('mkt.comment.praiseTitle') : i18n.t('mkt.comment.badTitle')}</div>
              </div>
              <div className='right'>
                <div
                  className={`zan-item ${score === 5 ? 'selected' : ''}`} onClick={() => {
                    setScore(5)
                    setTag([])
                  }}
                >
                  <i className='iconfont icon-zan'></i>
                </div>
                <div
                  className={`zan-item bad ${score === 1 ? 'selected' : ''}`} onClick={() => {
                    setScore(1)
                  }}
                >
                  <i className='iconfont icon-zan'></i>
                </div>
              </div>
            </div>
            <div className='message-area'>
              <div className='message-tag'>
                {
                  tag.map((item: any) => {
                    return <span key={item}>@{i18n.t(`mkt.common.${item}`)}</span>
                  })
                }
              </div>
              <div className='message-text'>
                {
                  !message &&
                    <>
                      <i className='iconfont icon-edit1'></i>
                      <span>{i18n.t('mkt.comment.tellMeHappened')}</span>
                    </>
                }
                <textarea
                  value={message} maxLength={400}
                  onChange={(e: any) => {
                    setMessage(e.target.value)
                  }}
                >
                </textarea>
              </div>
            </div>
            <div className='upload-area'>
              <div className='upload-img'>
                {
                  medias.map((item: any, index: number) => {
                    return (
                      <div key={index} className='img-item' style={{ backgroundImage: `Url(${item.url})` }}>
                        <div
                          className='close-icon' onClick={() => {
                            const resArr: any[] = cloneDeep(medias)
                            resArr.splice(index, 1)
                            setMedias(resArr)
                          }}
                        >
                          <i className='iconfont icon-delete'></i>
                        </div>
                      </div>
                    )
                  })
                }
                {
                  medias.length < 6 &&
                    <div className='img-item'>
                      <UploadInput
                        len={medias.length}
                        max={6}
                        onChange={(res: any[]) => {
                          console.log('res', res)
                          const resArr: any[] = cloneDeep(medias)
                          each(res, (item: any) => {
                            resArr.push({
                              type: 'picture',
                              url: item.url
                            })
                          })
                          setMedias(resArr)
                        }}
                      >
                      </UploadInput>
                    </div>
                }
              </div>
              {score === 5 && <div className='message-num'>{message.length}/400</div>}
            </div>
            {
              score === 1 &&
                <div className='footer-area'>
                  <div className='tag-area'>
                    <div
                      className={`tag-item ${tag.includes('boss') ? 'selected' : ''}`} onClick={() => {
                        changeTag('boss')
                      }}
                    >@{i18n.t('mkt.common.boss')}
                    </div>
                  </div>
                  <div className='message-num'>{message.length}/400</div>
                </div>
            }
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <MktButton onClick={() => {
          onSubmit()
        }}
        >
          <span>{i18n.t('mkt.comment.postComment')}</span>
        </MktButton>
      </IonFooter>
    </IonPage>
  )
}

export default observer(GiftCard)
